export function uniqueId() {
    const encode = (number: number) => number.toString(16);

    return 'id-' + encode(Date.now()) + '-' + encode(Math.random()).slice(2);
}
